enum TemporaryFilterField {
  ASSIGNEE = 'assignee',
  BIRTHDAY_MONTH = 'birthdayMonth',
  BORN_DATE_RANGE = 'bornDateRange',
  CONNECTION_CONSTITUENT = 'connectionConstituent',
  CONSTITUENT_LABELS = 'constituentLabels',
  CONTRIBUTION_LABELS = 'contributionLabels',
  CUSTOM_FIELDS = 'customFields',
  DONATION_DATE_RANGE = 'donationDateRange',
  DONATION_AMOUNT_RANGE = 'donationAmountRange',
  DONATION_HOURS_RANGE = 'donationHoursRange',
}

export default TemporaryFilterField;
